module.exports = __webpack_public_path__ + "static/img/8.91c39dd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/4/1/zh/8.png
// module id = KeGk
// module chunks = 0